module.exports = __webpack_public_path__ + "img/judi-ava.a25c53f.png";